<template>
  <div class="table-container">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
              ><strong>{{ sidebarFilterName(name, context) }}</strong
              >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23"/>
        <span style="font-size: 14px; font-weight: 500">{{
            computedFilterTitle
          }}</span>
      </b-button-group>
      <export-options
        :filter="filter"
        :options="[{ code: 'LOGCOM', label: null, formats: ['csv'] }]"
      ></export-options>
      <b-button
        type="button"
        variant="secondary"
        size="sm"
        class="btn--smaller btn--transparent"
        @click="onRefreshContent()"
        title="Refresh"
      >
        <base-icon name="reload" width="20" height="20" />
        Ricarica
      </b-button>
    </actions-toolbar>

    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item">
              <base-select
                name="type"
                label="Tipo"
                v-model="filter.type"
                :options="types"
                :taggable="false"
                :multiple="false"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="status"
                label="Stato"
                v-model="filter.status"
                :options="status"
                :taggable="false"
                :multiple="false"
              />
            </div>
            <div class="filter-item">
              <base-datepicker
                name="start"
                label="Data da"
                v-model="filter.start"
              />
            </div>
            <div class="filter-item">
              <base-datepicker name="end" label="Data a" v-model="filter.end"/>
            </div>
            <div class="filter-item">
              <base-input
                vid="procedure_id"
                name="procedure_id"
                label="ID procedura"
                v-model="filter.procedure_id"
                :placeholder="`Inserisci l'ID della procedura`"
              />
            </div>
            <div class="filter-item">
              <base-input
                vid="recipient"
                name="recipient"
                label="Recapito destinatario"
                v-model="filter.recipient"
                :placeholder="`Inserisci il recapito del destinatario`"
              />
            </div>
            <div class="filter-item">
              <base-input
                vid="registry_name"
                name="registry_name"
                label="Nominativo destinatario"
                v-model="filter.registry_name"
                :placeholder="`Inserisci il nominativo di un'anagrafica`"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
            >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
            >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <log
        :fields="fields"
        @manualFetch="manualFetch"
        :repository="repository"
        :filterName="filterName"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        :resource="resource"
        :ref="tableRef"
        :status="status"
      ></log>
    </div>
  </div>
</template>

<script>
import LisaComunicaMixin from "@/mixins/LisaComunicaMixin";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import Log from "@/components/tables/LisacomunicaLog.vue";
import ExportOptions from "@/components/ExportOptions";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import {mapActions} from "vuex";
import moment from "moment";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

moment.locale("it");

export default {
  mixins: [CustomFiltersMixin, LisaComunicaMixin, SidebarFilterMixin],
  data() {
    return {
      repository: "log",
      resource: "log",
      tableRef: "elogTableRef",
      filterName: "filterLog",
      context: "lisacomunica_logs",
      activeFilters: {},
      performedSearch: false,
      filter: this.initFilter(),
      status: [
        { value: "TEMP_FAILED", text: "Temporaneamente fallito" },
        { value: "FAILED", text: "Fallito" },
        { value: "OK", text: "Completato" },
        { value: "DELIVERED", text: "Consegnato" },
        { value: "OPENED", text: "Aperto" },
        { value: "SCHEDULED", text: "Programmato" },
      ],
      types: [
        { value: "EMAIL", text: "Email" },
        { value: "SMS", text: "SMS" },
        // { value: "PDF", text: "Pdf" },
      ],
      fields: [
        {
          key: "actions",
          label: "",
        },
        {
          key: "procedure_id",
          label: "ID Procedura",
          formatter: (value) => value ?? "-",
        },
        {
          key: "status",
          label: "Stato",
        },
        {
          key: "type",
          label: "Tipo",
          formatter: (value) => this.getType(value),
        },
        {
          key: "recipient",
          label: "Recapito destinatario",
        },
        {
          key: "recipient_entity_name",
          label: "Nominativo destinatario",
          formatter: (value) => value ?? "-",
        },
        {
          key: "timestamp",
          label: "Data e ora",
          formatter: (val) => {
            return moment(val).format("DD/MM/YYYY HH:mm:ss");
          },
        },
        {
          key: "error_message",
          label: "Messaggio di errore",
          formatter: (value) => value ?? "-",
        },
      ],
    };
  },
  components: {
    BaseIcon,
    Log,
    ExportOptions,
    BaseDatepicker,
    BaseInput,
    BaseSelect,
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  mounted() {
    // arrivo dalla lista procedure ("Vedi log"): pre-filtra per procedura e
    // ripulisce l'URL, così il filtro resta modificabile e non si ripresenta
    const procedureId = this.$route.query.procedure_id;
    if (procedureId) {
      this.filter.procedure_id = procedureId;
      this.$router.replace({ query: {} });
    }
    // default search on page load
    this.onSearch(this.filterName);
  },
  methods: {
    initFilter() {
      let init = {
        status: null,
        procedure_id: null,
        recipient: null,
        registry_name: null,
        type: null,
        start: null,
        end: null,
      };
      return init;
    },
    getType(value) {
      return this.types.find((type) => type.value === value).text;
    },
    onAdd() {
      this.$router.push({name: `logs.create`});
    },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      // una copia: la sidebar resta libera fino al prossimo Cerca
      let criteria = JSON.parse(JSON.stringify(this.filter));
      this.saveFilterByName({name, criteria});
      this.removePaginationByName(name);
      // stessa query string (e codifica) di paginazione, Ricarica e polling
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].perPage = 20;
      this.$refs[this.tableRef].requestPollingRestart();
      return this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    onSaveFilter(name, criteria) {
      this.saveFilterByName({name, criteria});
    },
    onRefreshContent() {
      // ricarica la pagina corrente con filtri, ordinamento e paginazione salvati;
      // niente richieste parallele se la tabella sta già caricando
      const table = this.$refs[this.tableRef];
      if (table.isLoading) return;
      table.requestPollingRestart();
      table.fetch();
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", {removePaginationByName: "removeByName"}),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
  },
};
</script>
